import React, { useState } from 'react';
import classes from './index.module.scss';
import { ReactComponent as EyeIcon } from '../../../assets/icons/eye-icon.svg'

const PasswordInput = ({ 
  name, 
  register, 
  regitration = true, 
  tabs = false,  
  onChange,
  placeholder,
  value, 
  info_type
}) => {
  const [passwordShown, setPasswordShown] = useState(false);

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  return (
    <div className={`${classes.Password_Input_Wrapper} ${tabs && classes.Edit_Profile_Width}`}>
      <input 
        name={name}
        type={passwordShown ? "text" : "password"}
        id={name}
        ref={register}
        placeholder={placeholder}
        onChange={onChange && ((event) => onChange(event, name, info_type))}
        value={value && value[name]}
      />
      {regitration && <EyeIcon 
        onClick={togglePasswordVisiblity}
      />}
    </div>
  )
}

export default PasswordInput;